module.exports = __webpack_public_path__ + "media/icons/zdjecia@3x-474d001b.svg";